import mountVueOnPage from '../mount_vue'

// Keep in sync with UsersController::USERS_PER_PAGE.
const PER_PAGE = 48

mountVueOnPage('users', 'index', {
    data() {
        return {
            users: [],
            search: '',
            filter: 'last_active',
            page: 0,
            done: false,
            loading: false,
            ready: false, // false until the first page resolves — drives the content spinner

            searchTimer: null,
            observer: null,
            loadTimer: null,
        }
    },
    async created() {
        await this.reload()
        this.ready = true
    },
    mounted() {
        // Load the next page only when a bottom sentinel actually scrolls into
        // view (not on raw scroll math, which fired far too eagerly).
        // Load ONE page each time the sentinel enters view, then disarm until it
        // leaves again. Otherwise appending rows keeps it in view and fires
        // several loads back-to-back.
        // Debounce the trigger so a burst of observer callbacks (from scrolling
        // + appended rows) collapses into a single load; the loading guard in
        // loadMore prevents overlap.
        this.observer = new IntersectionObserver(
            (entries) => {
                if (!entries[0].isIntersecting) return
                clearTimeout(this.loadTimer)
                this.loadTimer = setTimeout(() => this.loadMore(), 250)
            },
            { rootMargin: '80px' },
        )
        if (this.$refs.sentinel) this.observer.observe(this.$refs.sentinel)
    },
    unmounted() {
        if (this.observer) this.observer.disconnect()
    },
    methods: {
        // Bound to the search box; debounced so we don't fetch on every keystroke.
        update() {
            clearTimeout(this.searchTimer)
            this.searchTimer = setTimeout(() => this.reload(), 200)
        },
        async reload() {
            this.page = 0
            this.done = false
            this.users = []
            await this.loadMore()
        },
        async loadMore() {
            if (this.loading || this.done) return
            this.loading = true
            try {
                const res = await axios.get('/users.json', {
                    params: { search: this.search, filter: this.filter, page: this.page },
                })
                const batch = res.data || []
                this.users.push(...batch)
                this.done = batch.length < PER_PAGE
                this.page += 1
            } finally {
                this.loading = false
            }
        },
    },
    watch: {
        async filter() {
            await this.reload()
        },
    },
})
